import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PropertyInformationPopoverError() {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "badRequest",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.propertyInformationPopover.error.title"
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.propertyInformationPopover.error.message"
    })
  });
}